import { isDateInNextDays } from 'dateUtils';
import { DataRoomShareableLink } from 'models/ShareableLink';
import { getIsArrayEmpty } from 'utils';

export const getRowBackgroundColor = (link: DataRoomShareableLink) => {
  const { isActive, linkExpiresDate, totalAccessCount, fileIds } = link;

  if (getIsArrayEmpty(fileIds)) return 'files-deleted-row';

  if (isActive && linkExpiresDate && isDateInNextDays(linkExpiresDate, 7))
    return 'expires-soon-row';

  if (totalAccessCount) return 'analytics-row';

  return '';
};
